import * as yup from 'yup';

export const FIELD_EXPLANATION = 'explanation';

export const AttestationInterruptValidationForm = yup.object().shape({
  explanation: yup.string().required('error.required').trim(),
});
